import React from 'react';

import Header from '../partials/Header';
import PageIllustration from '../partials/PageIllustration';
import BlogFeatured from '../partials/BlogFeatured';
import Newsletter from '../partials/Newsletter';
import Footer from '../partials/Footer';
import BlogList from '../partials/BlogList';

function Blog() {
  
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Header />
      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page illustration */}
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none" aria-hidden="true">
          <PageIllustration />
        </div>
        {/*  Page sections */}
        <BlogFeatured />
        <BlogList />
        <Newsletter />
      </main>
      {/*  Site footer */}
      <Footer />
    </div>
  );
}

export default Blog;